module.exports = __webpack_public_path__ + "img/HE7101-112.5a08155a.jpg";